import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';

import ErrorWrapper from './ErrorWrapper';

export function RouterErrorBoundary({ fallback }: { fallback?: React.ReactNode }) {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <div id="error-boundary">
      <ErrorWrapper title="Something went wrong">
        An unexpected error has occurred. Please try refreshing the page or contact support if the problem persists.
      </ErrorWrapper>
    </div>
  );
}
